import { type TRPCClient } from '@trpc/client';

import { createTrpcClient } from '@infinex-private/connect-client';
import { type ConnectWorkerRouter } from '@infinex/connect-service-contract/client';
import { HEADER_NAME_CONNECT_TRANSACTION_ID } from '@infinex/types';
import { createMainServiceQueryClient } from '@infinex/user';

export type { ConnectWorkerRouter, TRPCClient };
export type ConnectWorkerClient = TRPCClient<ConnectWorkerRouter>;

// Create a new QueryClient instance
export const queryClient = createMainServiceQueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

export const trpcUrl = `${window.location.protocol}//${window.location.host}/trpc`;

export const globalHeaders = new Headers();
export function setGlobalDappId(dappId: string): void {
  globalHeaders.set('x-dapp-id', dappId);
}

export function setTraceId(traceId: string): void {
  globalHeaders.set(HEADER_NAME_CONNECT_TRANSACTION_ID, traceId);
}

// Create a TRPC client
export const trpcClient = createTrpcClient(trpcUrl, globalHeaders);
